// extracted by mini-css-extract-plugin
export default {"deletedWidget":"cjUhmF9u3oHJhfGftMa8L","active":"_1a7bYbudDRkwxSsd0s-B-0","pointer":"_20gXEFuiT7qKB0zaXnT3G1"};